import { useTranslation } from "next-i18next";

import BestPracticeBanner, {
  BestPracticeBannerBgPattern,
} from "@/components/BestPracticeBanner/BestPracticeBanner";

export function ProfJourneyBestPracticeBanner({
  className,
}: {
  className?: string;
}) {
  const { t } = useTranslation();

  return (
    <BestPracticeBanner
      className={className}
      bgPattern={BestPracticeBannerBgPattern.Pattern2}
      title={t("application:profJourney.bestPracticeBanner.title")}
      text={t("application:profJourney.bestPracticeBanner.text")}
      buttonText={t("application:profJourney.bestPracticeBanner.buttonText")}
      buttonHref="https://immigram.notion.site/How-to-describe-your-deeds-and-achievements-8b4101a1dfe548229efbf91753d6ee92"
    />
  );
}
